import React from "react";
import {
    Dialog,
    DialogContent,
    DialogActions,
    Box,
    Typography,
    IconButton,
    TextField,
    Button
} from "@mui/material";
import { useForm } from "react-hook-form";
import CloseIcon from "@mui/icons-material/Close";
import { ThumbDown } from "@mui/icons-material";

type Props = {
    open: boolean;
    onClose: () => void;
    feedbackText: string;
    onFeedbackChange: (val: string) => void;
    onSubmit: (feedback: string) => void;
};

const FeedbackModal = ({
    open,
    onClose,
    feedbackText,
    onFeedbackChange,
    onSubmit
}: Props) => {
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
      } = useForm<{ feedback: string }>({
        defaultValues: { feedback: feedbackText },
      });

    const handleFormSubmit = (data: { feedback: string }) => {
        onFeedbackChange(data.feedback);
        onSubmit(data.feedback);
        reset();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" PaperProps={{ sx: { borderRadius: 4 } }}>
            <Box display="flex" alignItems="center" justifyContent="space-between" px={3} pt={2}>
                <Box display="flex" alignItems="center" justifyContent="center" flex={1} gap={1}>
                    <ThumbDown sx={{ color: "#A68BD0" }} />
                    <Typography fontWeight={700}>Additional Feedback</Typography>
                </Box>
                <IconButton onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </Box>

            <Box px={3}>
                <form onSubmit={handleSubmit(handleFormSubmit)}>
                    <DialogContent sx={{ p: '0px' }}>
                        <Typography variant="body2" textAlign="center" mb={2}>Help us improve our recommendations.</Typography>
                        <TextField
                            {...register("feedback", { required: "Feedback is required." })}
                            fullWidth
                            placeholder="Add your comments..."
                            multiline
                            rows={3}
                            error={!!errors.feedback}
                            helperText={errors.feedback?.message} 
                            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
                        />

                    </DialogContent>
                    <DialogActions sx={{ mt: 2, mb: 2 }}>
                        <Button
                            type="submit"
                            variant="contained"
                            fullWidth
                            sx={{
                                height: 56,
                                backgroundColor: "#5921F2",
                                borderRadius: 2,
                                textTransform: "none",
                                fontSize: 18,
                            }}>
                            Submit
                        </Button>
                    </DialogActions>
                </form>
            </Box>
        </Dialog>
    );
};

export default FeedbackModal;
